<template>
  <div>
    <filter-option-trial-days
      :trial-days="trialDays"
      @update:trialDays="$emit('update:trialDays', $event)"
    />

    <div v-if="visibleCustomerSegments && visibleCustomerSegments.length > 0">
      <div class="title">
        <gl-sub-text>顧客セグメント</gl-sub-text>
      </div>
      <div class="content">
        <md-radio
          v-for="e in visibleCustomerSegments"
          :key="e"
          v-model="_customerSegment"
          :value="e"
          :gl-tooltip="`${e === 'rank' ? rankThresholds : ''}`"
          gl-tooltip-direction="down"
        >
          {{ $store.state.labels.customerSegment[e] }}
        </md-radio>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import CUSTOMER_SEGMENTS from '@/const/customersegments'
import FilterOptionTrialDays from '@/components/FilterOptionTrialDays.vue'

function isValidCustomerSegmentValues(values) {
  for (const v of values) {
    if (!CUSTOMER_SEGMENTS.includes(v)) {
      return false
    }
  }
  return true
}

export default {
  mixins: [ErrorReport],
  components: {
    FilterOptionTrialDays,
  },
  data() {
    return {
      rankThresholds: '',
    }
  },
  props: {
    trialDays: {
      type: Number,
    },
    customerSegment: {
      type: String,
      validator: value => CUSTOMER_SEGMENTS.includes(value),
    },
    visibleCustomerSegments: {
      type: Array,
      default: () => [...CUSTOMER_SEGMENTS],
      validator: isValidCustomerSegmentValues,
    },
  },
  computed: {
    _customerSegment: {
      get() {
        return this.customerSegment
      },
      set(newVal) {
        this.$emit('update:customerSegment', newVal)
      },
    },
    errors() {
      const errors = []

      if (!this.trialDays || this.trialDays < 1) {
        errors.push('初購入を選択してください')
      }

      if (
        this.visibleCustomerSegments &&
        this.visibleCustomerSegments.length > 0 &&
        !this.customerSegment
      ) {
        errors.push('顧客セグメントを選択してください')
      }

      return errors
    },
  },
  async created() {
    const ranks = await this.$repositories.get('rank').get('dummy')
    const mThresholds = ranks.thresholds
      .find(rank => rank.type === 'm')
      .values.map((rank, index) => `M${index + 1}: ${rank}`)
      .join(' ')

    const fThresholds = ranks.thresholds
      .find(rank => rank.type === 'f')
      .values.map((rank, index) => `F${index + 1}: ${rank}`)
      .join(' ')

    this.rankThresholds = mThresholds + ' ' + fThresholds
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}

.option-inline {
  display: flex;
}

.option-input {
  width: 60px;
}

.option-field {
  width: 60px;
}

.option-label {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 16px;
  margin-right: 16px;
}
</style>
